<template>
  <Modal
    v-model="qyShowModelNew"
    title="企业加盟"
    :mask-closable="false"
    width="600"
  >
    <Input
      v-model="qyInput"
      size="large"
      placeholder="请输入企业名称"
      style="width: 560px;padding-top:15px;"
      :maxlength="maxlength"
      :clearable="clearable"
    />
    <div class="qy-searchcard-wrapper">
      <div style="padding: 20px 0">请选择企业类型</div>
      <CheckboxGroup @on-change="clickCheckBox" v-model="selectType">
        <Checkbox
          v-for="(item,index) in qyType"
          :label="item.id"
          style="margin-right:16px;margin-bottom:10px"
        >{{item.name}}</Checkbox>
      </CheckboxGroup>
    </div>

    <div v-if="showSelectBar">
      <Select v-model="selName" @on-change="selChange" placeholder="请选择小区">
        <Option v-for="item in shequ" :value="item.id" :key="item.id">{{ item.name }}</Option>
      </Select>
    </div>
     <div slot="footer">
   	<Button type="text" size="large" @click="modalCancel">取消</Button>
   	<Button type="primary" size="large" @click="addQy">确定</Button>
   </div>
  </Modal>
</template>

<script>
var that;
export default {
  props: {
    qyShowModel: {
      type: Boolean,
      default: false,
    },
    rule: {
      type: Object,
    },
  },
  watch: {
    qyShowModel(newValue, oldValue) {
      this.qyShowModelNew = newValue;
    },
  },
  components: {},
  data() {
    return {
      qyInput: "", //输入的企业名字
      selectType: [], //选择的类型id集合
      qyType: "", //企业类型集合
      clearable: true,
      maxlength: 120,
      qyShowModelNew: false,
      selName: [],
      shequ: [],
      showSelectBar: false
      // selectRule:{}
    };
  },
  methods: {
    getQyType() {
      let url = this.urlobj.getQYType;
      let data = {
        type: "type",
      };
      that.$get(url, data).then((res) => {
        console.log(res);
        that.qyType = res.rows.map((item) => {
          return {
            name: item.title,
            id: item.id,
            remark: item.remark,
            selected: false
          };
        });
      });
    },
    clickCheckBox(item) {
      console.log(item)
      console.log(this.selectType);

      this.qyType.forEach(element => {
        if(item && item.includes(element.id)) {
          element.selected = true
        } else {
           element.selected = false
        }
      });
      let list = this.qyType;
      console.log(list);
      this.showSelectBar = list.filter(i=>i.selected).some(this.checkRemark)
    },
    checkRemark(item) {
      return (
        item.remark == "company_type_tenement" ||
        item.remark == "company_type_water" ||
        item.remark == "company_type_heating" ||
        item.remark == "company_type_operation"
      );
    },
    selChange(val) {
      console.log(this.selName);
      // this.detailItem.zone = val;
    },
    getMiniShequ() {
      var url = this.urlobj.getOrg();
      var data = {
        communityId: this.$store.state.streetorcommunityid,
        zoneType: 1,
      };
      this.$get(url, data).then((res) => {
        var list = res.rows.map((item) => {
          return {
            name: item.zoneName,
            id: item.zoneId,
          };
        });
        this.shequ = list;
        console.log(list);
      });
    },
    addQy() {
      if (!that.qyInput) {
        that.$Message.warning("请输入企业名称");
        this.$emit("closeModel", { init: false });
        return;
      }
      this.$post(this.urlobj.addQy, {
        companyName: that.qyInput,
        typeIdList: that.selectType,
        communityId: that.rule.communityIdList.join(","),
        zoneId: typeof this.selName != "object" ? this.selName: ''
      })
        .then((res) => {
          if (res.isSucceed) {
            this.qyInput = "";
            that.$Message.success("添加成功");
            this.$emit("closeModel", { init: true, id: res.newPrimaryKeys.id });
          } else {
            this.$emit("closeModel", { init: false });
          }
        })
        .catch((e) => {
          this.$emit("closeModel", { init: false });
        });
    },
    modalCancel() {
      this.qyShowModelNew = false;
      this.$emit("closeModel", { init: false });
    },
  },
  mounted() {
    that = this;
    that.getQyType();
  },
  created() {
    this.getMiniShequ();
  },
};
</script>

<style scoped>
.qy-searchcard-wrapper {
  /* height: 300px; */
}
</style>
